import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { SuiModule } from '@external/ng2-semantic-ui';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { OrderModule } from 'ngx-order-pipe';
import { GraphComponent } from './graph/graph.component';
import { RealtimeComponent } from './realtime/realtime.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    GraphComponent,
    RealtimeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SuiModule,
    NgxEchartsModule.forRoot({
        echarts,
      }),
    OrderModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
